import investor_service from "@/services/InvestorService";

const state = {
    all_customers:[],
    all_payments:[],
    all_packages:[],
    total_items:0
}

const getters = {
    getInvestorCustomers: (state) => {
        return state.all_customers;
    },
    getPackages: (state) => {
        return state.all_packages;
    },
    getPayments: (state) => {
        return state.all_payments;
    },
}

const mutations = {
    updateCustomer: (state,payload) =>{
        state.all_customers = payload;
        state.total_items = payload.total
    },
    updatePayment: (state,payload) =>{
        state.all_payments = payload;
        state.total_items = payload.total
    },
    updatePackage: (state,payload) =>{
        state.all_packages = payload;
        state.total_items = payload.total
    }
}

const actions = {
    updateCustomer({commit},payload) {
        return investor_service.customers(payload).then(
            response => {
                commit('updateCustomer',response);
               return Promise.resolve(response)
            },
            error => {
             return Promise.reject(error);
            }
        )
    },
    updatePackage({commit},payload) {
        return investor_service.packages(payload).then(
            response => {
                commit('updatePackage',response);
                return Promise.resolve(response)
            },
            error => {
                return Promise.reject(error);
            }
        )
    },
    updatePayment({commit},payload) {
        return investor_service.payments(payload).then(
            response => {
                commit('updatePayment',response);
                return Promise.resolve(response)
            },
            error => {
                return Promise.reject(error);
            }
        )
    }
}


export default {
    namespace: true,
    state,
    getters,
    mutations,
    actions
}

